import { render, staticRenderFns } from "./IndicesCorrecaoValidos.vue?vue&type=template&id=631a004c&scoped=true&"
import script from "./IndicesCorrecaoValidos.vue?vue&type=script&lang=js&"
export * from "./IndicesCorrecaoValidos.vue?vue&type=script&lang=js&"
import style0 from "./IndicesCorrecaoValidos.vue?vue&type=style&index=0&id=631a004c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631a004c",
  null
  
)

export default component.exports